import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { WebEditPageShell } from '../../../components/cv/WebEditPageShell';
import { EditExperienceForm } from '../../../components/cv/forms/EditExperienceForm';
import { useCVData } from '../../../lib/cv-mock-data';
import { useUpsertExperience, useDeleteExperience } from '../../../hooks/useProfileApi';
import { mapExperienceToAPI } from '../../../lib/cv-mapping';
import { assertCvItemBatchSaved } from '../../../lib/cv-write-coordinator';

export default function EditExperienceWebScreen() {
  const { t } = useTranslation('seeker');
  const { profile, profileRef } = useCVData();
  const upsertExp = useUpsertExperience();
  const deleteExp = useDeleteExperience();
  const initialIdsRef = useRef(new Set(profile.experience.map((e) => e.id)));

  const handleSave = async () => {
    const items = profileRef.current.experience;
    const currentIds = new Set(items.map((e) => e.id));
    const removedIds = [...initialIdsRef.current].filter((id) => !currentIds.has(id));
    const results = await Promise.allSettled([
      ...items.map((exp, i) => upsertExp.mutateAsync(mapExperienceToAPI(exp, i))),
      ...removedIds.map((id) => deleteExp.mutateAsync(id)),
    ]);
    // One save, one answer: a CV conflict choice (B02) is reported as such;
    // otherwise only a save where every item failed is a failure.
    assertCvItemBatchSaved(results);
  };

  return (
    <WebEditPageShell title={t('cv.edit.experience')}>
      <EditExperienceForm onSave={handleSave} />
    </WebEditPageShell>
  );
}
